'use strict';

import { prepareVideos } from '../../api/media/video';
import {waitForDependencies} from "../_imports/utils/utils.common";

waitForDependencies(() => {
    prepareVideos();
});